import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PipeModule } from '@core/pipe/pipe.module';
import { SharedModule } from '@core/shared.module';

import { BroadcastDebugComponent } from './broadcast-debug/broadcast-debug.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { FormStatusComponent } from './form-status/form-status.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { LogoComponent } from './logo/logo.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PanelSpacerComponent } from './panel-spacer/panel-spacer.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ToastItemComponent } from './toast-item/toast-item.component';
import { ToastComponent } from './toast/toast.component';

import {
  AutoFocusDirective,
  ClearButtonComponent,
  ComboBoxComponent,
  DateComponent,
  DecimalComponent,
  DisplayOnlyComponent,
  HintComponent,
  LabelComponent,
  MatchTypeComponent,
  ModalListboxComponent,
  MoneyComponent,
  MultiInputComponent,
  PopupLovComponent,
  TextInputDirective,
  ValidationComponent,
} from './controls';
import {
  CarrierLookupComponent,
  ConsigneeLookupComponent,
  CustomerConsigneeLookupComponent,
  CustomerLookupComponent,
  FacilityLookupComponent,
  ItemLookupComponent,
  SupplierLookupComponent,
} from './form-controls';
import {
  ColumnsComponent,
  ContextMenuComponent,
  ExportComponent,
  FilterComponent,
  LegendComponent,
  LegendEntryComponent,
  LoadGridDialogComponent,
  NoResultsComponent,
  SaveGridDialogComponent,
  SortIconComponent,
  TableBodyCellComponent,
  TableComponent,
  TableFooterCellComponent,
  TableHeaderCellComponent,
} from './grid';

const components = [
  AutoFocusDirective,
  BroadcastDebugComponent,
  CarrierLookupComponent,
  ClearButtonComponent,
  ColumnsComponent,
  ComboBoxComponent,
  ConfirmDialogComponent,
  ConsigneeLookupComponent,
  ContextMenuComponent,
  CustomerConsigneeLookupComponent,
  CustomerLookupComponent,
  DateComponent,
  DecimalComponent,
  DisplayOnlyComponent,
  ExportComponent,
  FacilityLookupComponent,
  FilterComponent,
  FormStatusComponent,
  HintComponent,
  ItemLookupComponent,
  LabelComponent,
  LegendComponent,
  LegendEntryComponent,
  LoadGridDialogComponent,
  LoadingOverlayComponent,
  LogoComponent,
  MatchTypeComponent,
  ModalListboxComponent,
  MoneyComponent,
  MultiInputComponent,
  NoResultsComponent,
  NotificationsComponent,
  PanelSpacerComponent,
  PopupLovComponent,
  SaveGridDialogComponent,
  SortIconComponent,
  SpinnerComponent,
  SupplierLookupComponent,
  TableBodyCellComponent,
  TableComponent,
  TableFooterCellComponent,
  TableHeaderCellComponent,
  TextInputDirective,
  ToastComponent,
  ToastItemComponent,
  ValidationComponent,
];

@NgModule({
  declarations: components,
  imports: [CommonModule, SharedModule, PipeModule],
  exports: components,
})
export class ComponentsModule {}
